
/*!
 * Roughly
 * https://github.com/dahjson/roughly
 * Copyright (c) Daniel Johnson
 */
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

(function($) {
  var Roughly;
  Roughly = (function() {
    function Roughly(element, options) {
      var date, ref, ref1, ref2, ref3, ref4, ref5, ref6, today;
      this.element = element;
      this.updateCounter = bind(this.updateCounter, this);
      this.startDate = (ref = this.element.data('start-date')) != null ? ref : options.startDate;
      this.startCount = (ref1 = this.element.data('start-count')) != null ? ref1 : options.startCount;
      this.waitSeconds = (ref2 = this.element.data('wait-seconds')) != null ? ref2 : options.waitSeconds;
      this.increaseBy = (ref3 = this.element.data('increase-by')) != null ? ref3 : options.increaseBy;
      this.decimals = (ref4 = this.element.data('decimals')) != null ? ref4 : options.decimals;
      this.prefix = (ref5 = this.element.data('prefix')) != null ? ref5 : options.prefix;
      this.postfix = (ref6 = this.element.data('postfix')) != null ? ref6 : options.postfix;
      this.startCount = parseFloat(this.removeCommas(this.startCount));
      this.waitSeconds = parseFloat(this.removeCommas(this.waitSeconds));
      this.increaseBy = parseFloat(this.removeCommas(this.increaseBy));
      this.decimals = parseFloat(this.removeCommas(this.decimals));
      date = Math.round(new Date(this.startDate).getTime() / 1000);
      today = Math.round(new Date().getTime() / 1000);
      this.startCount += Math.round((today - date) / this.waitSeconds);
      this.setCounter();
      setInterval(this.updateCounter, this.waitSeconds * 1000);
    }

    Roughly.prototype.updateCounter = function() {
      this.startCount += this.increaseBy;
      return this.setCounter();
    };

    Roughly.prototype.setCounter = function() {
      return this.element.text(this.prefix + this.addCommas(this.startCount.toFixed(this.decimals)) + this.postfix);
    };

    Roughly.prototype.addCommas = function(num) {
      return num.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    };

    Roughly.prototype.removeCommas = function(num) {
      return num.toString().replace(/,/g, '');
    };

    return Roughly;

  })();
  $.fn.roughly = function(options) {
    var defaults, settings;
    defaults = {
      startDate: 'January 1, 1970',
      startCount: 0,
      waitSeconds: 1,
      increaseBy: 1,
      decimals: 0,
      prefix: '',
      postfix: ''
    };
    settings = $.extend({}, defaults, $.fn.roughly.defaults, options);
    return new Roughly($(this), settings);
  };
  return $(function() {
    return $('.roughly').each(function() {
      return $(this).roughly();
    });
  });
})(this.jQuery);
